/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by kyang on 2/14/20.
 */

function RequestServiceConstructor(
    this: JS5Object,
    _: JS5Object,
    $q: JS5Object,
    $timeout: any,
    $window: JS5Object,
    PaginationService: JS5Object,
) {

    //==============//
    // Page Queries //
    //==============//

    // TODO: Replace PaginationService.pageDataResource usage with this function?
    // TODO: Replace PaginationService.queryForNewPageData() usage with this function?
    // queryFn - Function that makes a request for data, and returns a promise with that data.
    //           If request passed the last page of data,
    //           it should also update PaginationService.currentPage
    // isPageEmptyFn - Function that checks if the response is empty.
    //                 Is called with the value returned by queryFn's promise
    //                 Defaults to _.isEmpty
    this.queryForNewData = (queryFn: JS5Function, isPageEmptyFn: JS5Function = _.isEmpty) => {
        let previousPage = PaginationService.currentPage;
        return queryFn().then((pageData: any) => {
            if (isPageEmptyFn(pageData) && PaginationService.currentPage !== previousPage) {
                return this.queryForNewData(queryFn, isPageEmptyFn);
            }
            return pageData;
        });
    };


    //=================//
    // Page Visibility //
    //=================//

    /* Returns a promise. Promise resolves when page is visible. */
    this.whenPageVisible = () => {
        let deferred = $q.defer();
        if ($window.document.hidden) {
            this.visibilityPromises.push(deferred);
        } else {
            deferred.resolve();
        }
        return deferred.promise;
    };

    const onVisibilityChange = () => {
        if (!$window.document.hidden && this.visibilityPromises.length > 0) {
            _.forEach(this.visibilityPromises, (deferred: JS5Object) => {
                deferred.resolve();
            });
            this.visibilityPromises = [];
        }
    };


    //===================//
    // Request Intervals //
    //===================//

    let nextIntervalId = 0;
    this.intervals = {};

    const intervalCallback = (interval: JS5Object) => {
        const waitPromise = interval.waitForPageVisibility ? this.whenPageVisible() : $q.when();
        waitPromise
            .then(interval.promiseFunc)
            .finally(() => {
                if (this.intervals[interval.id]) {
                    interval.timeoutPromise = $timeout(intervalCallback.bind(this, interval), interval.delay);
                }
            });
    };

    // options has 2 possible keys: startImmediately, waitForPageVisibility
    this.createRequestInterval = (promiseFunc: JS5Function, delay: number, options?: JS5Object) => {
        this.initialize();
        let newInterval: JS5Object = {
            id: nextIntervalId,
            promiseFunc: promiseFunc,
            waitForPageVisibility: _.get(options, 'waitForPageVisibility', true),
            delay: delay,
        };
        this.intervals[nextIntervalId++] = newInterval;
        if (_.get(options, 'startImmediately', false)) {
            intervalCallback(newInterval);
        } else {
            newInterval.timeoutPromise = $timeout(intervalCallback.bind(this, newInterval), delay);
        }
        return newInterval.id;
    };

    this.cancelRequestInterval = (intervalId: number) => {
        let interval = this.intervals[intervalId];
        if (interval) {
            if (interval.promiseFunc) {
                $timeout.cancel(interval.timeoutPromise);
            }
            delete this.intervals[intervalId];
        }
    };

    this.initialize = () => {
        if (!this.visibilityPromises) {
            this.visibilityPromises = [];
            $window.document.addEventListener('visibilitychange', onVisibilityChange);
        }
    };
}

angular
    .module('prism-ui.components.data')
    .service('RequestService', RequestServiceConstructor);
